import request from '@/utils/request'
// 查询【客户联系人】列表
export function listOrder(query) {
  return request({
    url: '/scrm/custorder/list',
    method: 'get',
    params: query
  })
}
// 查询【客户联系人】详细
export function getOrder(custOrderId) {
  return request({
    url: '/scrm/custorder/' + custOrderId,
    method: 'get'
  })
}

// 新增【客户联系人】
export function addOrder(data) {
  return request({
    url: '/scrm/custorder',
    method: 'post',
    data: data
  })
}

// 修改【客户联系人】
export function updateOrder(data) {
  return request({
    url: '/scrm/custorder',
    method: 'put',
    data: data
  })
}

// 查询【线索客户】列表
export function listCust(query) {
  return request({
    url: '/scrm/order/list',
    method: 'get',
    params: query
  })
}

// 查询【线索客户】详细
export function getCust(custId) {
  return request({
    url: '/scrm/order/' + custId,
    method: 'get'
  })
}

// 新增【线索客户】
export function addCust(data) {
  return request({
    url: '/scrm/order',
    method: 'post',
    data: data
  })
}

// 修改【线索客户】
export function updateCust(data) {
  return request({
    url: '/scrm/order',
    method: 'put',
    data: data
  })
}

// 删除【线索客户】
export function delCust(custId) {
  return request({
    url: '/scrm/order/' + custId,
    method: 'delete'
  })
}

// 释放【线索客户】
export function releaseCust(custId) {
  return request({
    url: '/scrm/order/release/' + custId,
    method: 'get'
  })
}


// 导出【线索客户】
export function exportCust(query) {
  return request({
    url: '/scrm/order/export',
    method: 'get',
    params: query
  })
}

// 下载客户导入模板
export function importTemplate() {
  return request({
    url: '/scrm/order/importTemplate',
    method: 'get'
  })
}

// 清洗线索

export function pushClue(data) {
  alert(JSON.stringify(data));
  return request({
    url: '/scrm/order/pushClue',
    method: 'post',
    data: data
  })
}
